import { createI18n } from "vue-i18n";
import deLanguage from "@/locales/de.json";
import enLanguage from "@/locales/en.json";
import { CustomLocalService } from "@/utilities/services/entities/CustomLocalService";

type Locale = "de" | "en";
type TranslationData = Record<string, any>;

const service = new CustomLocalService();

async function loadCustom(lang: Locale): Promise<TranslationData> {
    try {
        const res = await service.getLanguageByName(lang);

        if (res.statusCode!==0) {
            return {};
        }
        return res.value as TranslationData;
    } catch (err) {
        return {};
    }
}

function deepMerge(base: TranslationData, custom: TranslationData): TranslationData {
    const result: TranslationData = Array.isArray(base) ? [...base] : { ...base };

    for (const key in custom) {
        const baseValue = (base as any)?.[key];
        const customValue = custom[key];

        if (
            customValue &&
            typeof customValue === "object" &&
            !Array.isArray(customValue) &&
            baseValue &&
            typeof baseValue === "object" &&
            !Array.isArray(baseValue)
        ) {
            result[key] = deepMerge(baseValue, customValue);
        } else {
            result[key] = customValue;
        }
    }

    return result;
}

const i18n = createI18n({
    locale: "de",
    fallbackLocale: "en",
    legacy: false,
    globalInjection: true,
    messages: {
        de: deLanguage as TranslationData,
        en: enLanguage as TranslationData,
    },
});

export async function loadCustomLocales(): Promise<void> {
    const [customDe, customEn] = await Promise.all([loadCustom("de"), loadCustom("en")]);

    const mergedDe = deepMerge(i18n.global.getLocaleMessage("de"), customDe);
    const mergedEn = deepMerge(i18n.global.getLocaleMessage("en"), customEn);

    i18n.global.setLocaleMessage("de", mergedDe);
    i18n.global.setLocaleMessage("en", mergedEn);
}

const $t = (i18n.global as any).t;

export { i18n, $t };
